/** @typedef {'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun'} WeekdayKey */

/** @typedef {import('../state/playback-status-store.js').InactiveReason} InactiveReason */

/**
 * @param {string} tz
 * @param {Date} ref
 * @returns {{ day: WeekdayKey; hhmm: string }}
 */
export function nowInTimezone(tz, ref = new Date()) {
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: tz,
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  const parts = fmt.formatToParts(ref);
  const weekday = (parts.find((p) => p.type === 'weekday')?.value ?? '').toLowerCase().slice(0, 3);
  const hour = parts.find((p) => p.type === 'hour')?.value ?? '00';
  const minute = parts.find((p) => p.type === 'minute')?.value ?? '00';
  const hourNorm = hour === '24' ? '00' : hour;
  return { day: /** @type {WeekdayKey} */ (weekday), hhmm: `${hourNorm}:${minute}` };
}

/**
 * Plant TV operating window from cached manifest `deviceSchedule`.
 * @param {{ daysOfWeek?: string[]; startTime?: string; endTime?: string; timezone?: string } | null | undefined} deviceSchedule
 * @param {Date} [ref]
 */
export function isDeviceScheduleActive(deviceSchedule, ref = new Date()) {
  if (!deviceSchedule) return true;
  if (!deviceSchedule.daysOfWeek?.length) return true;

  const tz = deviceSchedule.timezone ?? 'Europe/Rome';
  const { day, hhmm } = nowInTimezone(tz, ref);
  if (!deviceSchedule.daysOfWeek.includes(day)) return false;
  const start = deviceSchedule.startTime ?? '00:00';
  const end = deviceSchedule.endTime ?? '23:59';
  return hhmm >= start && hhmm <= end;
}
